import React, { useState, useCallback, memo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import useLeaveFor from 'hooks/useLeaveFor';
import LeftArrowIcon from 'components/Icons/back';
import { KeyboardWrapper, SearchArrow, SearchText, SearchWrapper } from './StyledComponents';
import { isMinQueryLengthExceeded } from './utils';
import SearchResult from './SearchResult';
import { SearchPlaceholder } from './SearchPlaceholder';
import Keyboard from 'components/KeyboardSearch';

const MAX_QUERY_SIZE = 30;

const KEYBOARD_CONFIG = {
  straightOnly: false,
  straightOverlapThreshold: 0.1,
  leaveFor: {
    up: '@SEARCH_RESULTS_AREA', // This transition direction is controlled by SearchResultArea component
    left: '@MAIN_MENU',
  },
};

interface ISearch {
  initialQuery: string;
  isLoading: boolean;
  fetchSearch: (query: string) => void;
  resetSearchQuery: () => void;
  history: RouteComponentProps['history'];
}

const Search: React.FC<ISearch> = ({ initialQuery, fetchSearch, resetSearchQuery, history }) => {
  const [query, setQuery] = useState(initialQuery);
  const [isResultScrolled, setIsResultScrolled] = useState(false);

  const onQueryUpdated = useCallback(
    (query) => {
      setQuery(query);
      if (!Boolean(query)) resetSearchQuery();
      if (isMinQueryLengthExceeded(query)) fetchSearch(query);
    },
    [setQuery, fetchSearch, resetSearchQuery],
  );

  useLeaveFor(history, ({ pathname }) => {
    // todo: comment
    const isGoingDeep = ['details', 'player', 'search'].some((path) => pathname.includes(path));

    if (isGoingDeep) return;

    if (resetSearchQuery) resetSearchQuery();
  });

  return (
    <SearchWrapper>
      <KeyboardWrapper isShow={isResultScrolled}>
        <Keyboard
          onQueryUpdated={onQueryUpdated}
          maxQuerySize={MAX_QUERY_SIZE}
          query={query}
          config={KEYBOARD_CONFIG}
        />
      </KeyboardWrapper>
      {query.length <= 2 && <SearchPlaceholder description="You haven't searched yet anything" />}
      <SearchArrow isShow={isResultScrolled}>
        {' '}
        <LeftArrowIcon /> <SearchText>Search</SearchText>
      </SearchArrow>
      {query.length > 2 && (
        <SearchResult onContentFocus={(_, index) => setIsResultScrolled(index !== 0)} />
      )}
    </SearchWrapper>
  );
};

export default memo(Search);
